'use client'

import { useEffect } from 'react'
import { useTranslation, I18nextProvider } from 'react-i18next'
import { Button } from '@/components/ui/button'
import i18n from '@/lib/i18n'

// CWV-Rollout Phase 9 (Auftrag 31.07.2026): siehe not-found.tsx-Kommentar --
// eigene, in sich geschlossene I18nextProvider-Bindung, falls dieser
// Fehler-Boundary ohne einen bereits gemounteten Ahnen-Provider rendert.
function GlobalErrorContent({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const { t } = useTranslation()

  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h2 className="text-2xl font-bold">{t('error.title')}</h2>
      <p className="text-sm text-muted-foreground max-w-md text-center">{error.message}</p>
      <Button onClick={reset}>{t('error.retry')}</Button>
    </div>
  )
}

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <I18nextProvider i18n={i18n}>
      <GlobalErrorContent error={error} reset={reset} />
    </I18nextProvider>
  )
}
